let searchWrapper: HTMLElement;
const Search = {
    init: (element: HTMLElement) => {
        searchWrapper = element;
        Search.initAlpineData();
    },
    initAlpineData: () => {
        Search.addRemoveFilterButton();
    },
    addRemoveFilterButton: () => {
        searchWrapper.querySelectorAll('.remove-filter-button').forEach((button) => {
            button.addEventListener('click', () => {
                Search.removeFilter(button);
            });
        });
    },
    removeFilter: (button: Element) => {
        if (button.parentElement.getAttribute('data-param') === 'suche') {
            (searchWrapper.querySelector('#search-input') as HTMLInputElement).value = '';
            (searchWrapper.querySelector('.search-form') as HTMLFormElement).submit();
            return;
        }
        (searchWrapper.querySelector(`#${button.parentElement.getAttribute('data-value')}`) as HTMLInputElement).checked = false;
        (searchWrapper.querySelector('.search-form') as HTMLFormElement).submit();
    },
};

export default Search;
